import { render, staticRenderFns } from "./profitCenter.vue?vue&type=template&id=574d9114"
import script from "./profitCenter.vue?vue&type=script&lang=js"
export * from "./profitCenter.vue?vue&type=script&lang=js"
import style0 from "./profitCenter.vue?vue&type=style&index=0&id=574d9114&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports